import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  const formatViews = (views: number) => {
    if (views >= 100000000) return `${(views / 100000000).toFixed(1)}亿`;
    if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
    return views.toString();
  };

  return (
    <div className="group cursor-pointer" data-product-shop>
      <div className="relative overflow-hidden rounded-lg aspect-video mb-3">
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <span className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-xs px-2 py-0.5 rounded">
          {video.duration}
        </span>
        {video.isNew && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded font-medium">
            NEW
          </span>
        )}
        {video.isHot && !video.isNew && (
          <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded font-medium">
            热门
          </span>
        )}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 opacity-0 group-hover:opacity-100 transition-opacity transform scale-75 group-hover:scale-100">
            <i className="ri-play-fill text-xl"></i>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug mb-1 group-hover:text-primary-600 transition-colors">
        {video.title}
      </h3>
      <div className="flex items-center gap-2 text-xs text-foreground-500">
        <span>{video.year}</span>
        <span>·</span>
        <span>{formatViews(video.views)}次播放</span>
        <span>·</span>
        <span className="text-accent-600 font-medium">{video.rating}分</span>
      </div>
    </div>
  );
}